module.exports = __webpack_public_path__ + "img/antes_despues_116.f0b7a672.png";